export default __webpack_public_path__ + "media/images/banner/banner-7-2c34493890be9f33812d88abc41d8d73.jpg";